"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardTag_vue_1 = __importDefault(require("@/client/components/card/CardTag.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CardTags',
    props: {
        tags: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardTag: CardTag_vue_1.default,
    },
});
